import { INotification } from "../features/notification/interfaces"
import { updateNotifications } from "../features/notification/notificationSlice"

export const addNotification = ( data : INotification ) => async (dispatch:any) => {
    dispatch(updateNotifications(data))
}